import {GUEST_FORM_NAMES, SelectOption} from '@chekin/core';
import {AddFormType} from '../../../context/guest';
import {getIsSelectFieldType} from './common';

type HandleChangeLocation = {
  newValue: SelectOption | null;
  formFields: AddFormType;
  onReset: (fieldName: string) => void;
  currentValue?: string;
};
const handleChangeResidenceCountry = ({
  newValue,
  currentValue,
  onReset,
  formFields,
}: HandleChangeLocation) => {
  const isValueChanged = newValue?.value !== currentValue;

  const shouldResetCity =
    getIsSelectFieldType(formFields?.[GUEST_FORM_NAMES.residence_city]?.type) &&
    isValueChanged;

  const shouldResetProvince =
    getIsSelectFieldType(formFields?.[GUEST_FORM_NAMES.residence_province]?.type) &&
    isValueChanged;

  if (shouldResetCity) {
    onReset(GUEST_FORM_NAMES.residence_city);
  }
  if (shouldResetProvince) {
    onReset(GUEST_FORM_NAMES.residence_province);
  }
};

const handleChangeResidenceProvince = ({
  newValue,
  currentValue,
  onReset,
  formFields,
}: HandleChangeLocation) => {
  const shouldResetCity =
    getIsSelectFieldType(formFields?.[GUEST_FORM_NAMES.residence_city]?.type) &&
    newValue?.value !== currentValue;

  if (shouldResetCity) {
    onReset(GUEST_FORM_NAMES.residence_city);
  }
};

export {handleChangeResidenceCountry, handleChangeResidenceProvince};
